const {getFedOpsServerLogger, getFedOpsClientLogger} = require('./loggerFactory')

function getNumberOfPages(rendererModel) {
    return rendererModel.pageList.pages.length
}

function isSiteFromADI(clientSpecMap) {
    for (const key in clientSpecMap) {
        if (clientSpecMap.hasOwnProperty(key)) {
            if (clientSpecMap[key].type === 'onboarding' && clientSpecMap.inUse === true) {
                return true
            }
        }
    }

    return false
    // const onBoardingSpec = _.find(clientSpecMap, {type: 'onboarding'});
    // return _.get(onBoardingSpec, 'inUse', false) === true;
}

function getTAGS(rendererModel, {siteRevision}, biContext) {
    return {
        numberOfPages: getNumberOfPages(rendererModel),
        revision: siteRevision,
        geo: rendererModel.geo,
        metaSiteId: rendererModel.metaSiteId,
        isFromAdi: isSiteFromADI(rendererModel.clientSpecMap),
        isInRollout: biContext.is_rollout || biContext.isRollout ? 1 : 0,
        dataCenter: biContext.dc
    }
}

function getBiStore(rendererModel, {sessionInfo = {}}, biContext) {
    return {
        msid: rendererModel.metaSiteId,
        siteMemberId: sessionInfo.siteMemberId,
        visitorId: sessionInfo.visitorId,
        is_rollout: biContext.is_rollout || biContext.isRollout ? 1 : 0,
        is_headless: biContext.isBot,
        data_center: biContext.dc
    }
}

const addTagsFromObject = (scope, obj) => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            scope.setTag(key, obj[key])
        }
    }
}

const createLogger = (client, {rendererModel, publicModel, requestModel, rawUrl, boltBase, isInSSR, loggerModel, wixBiSession}) => {
    const release = boltBase.split('/').pop()
    const biContext = wixBiSession || loggerModel || {}

    client.configureScope(scope => {
        scope.addEventProcessor((event, hint) => {
            const {url} = event.request
            const {message, loggerParams} = hint.originalException

            if (url.includes('isqa=true') ||
                url.includes('suppressbi=true') ||
                message.includes('play() failed because the user didn\'t interact with the document first') ||
                message.includes('The play() request was interrupted by a call to pause()')) {
                return null
            }
            event.release = release

            if (loggerParams) {
                if (event.extra && event.extra.TypeError) {
                    delete event.extra.TypeError.loggerParams
                }

                const {tags, extra, fingerprint} = loggerParams
                if (tags) {
                    event.tags = event.tags || {}
                    Object.assign(event.tags, tags)
                }
                if (extra) {
                    event.extra = event.extra || {}
                    Object.assign(event.extra, extra)
                }
                if (fingerprint) {
                    event.fingerprint = fingerprint
                }
            }

            return event
        })

        scope.setUser({id: publicModel.externalBaseUrl})
        addTagsFromObject(scope, getTAGS(rendererModel, publicModel, biContext))
        addTagsFromObject(scope, publicModel.deviceInfo)
        addTagsFromObject(scope, {
            url: rawUrl,
            environment: boltBase.includes('localhost') ? 'Development' : 'Production',
            userAgent: requestModel.userAgent,
            ssr: isInSSR
        })
    })

    const getSentry = () => {
        if (isInSSR) {
            return client
        }

        window.Sentry.forceLoad()
        return window.Sentry
    }
    const biStore = getBiStore(rendererModel, publicModel, biContext)
    const fedopsLogger = isInSSR ? getFedOpsServerLogger(biStore) : getFedOpsClientLogger(biStore)

    return {
        enrichError: (e, {tags, extra, fingerprint} = {}) => {
            e.loggerParams = {tags, extra, fingerprint: ['{{ default }}', ...fingerprint]}
        },
        captureError: (e, {tags, extras, level = 'error', groupErrorsBy = 'tags'} = {}) => getSentry().withScope(scope => {
            const fingerprints = []
            for (const key in tags) {
                if (tags.hasOwnProperty(key)) {
                    scope.setTag(key, tags[key])
                    if (groupErrorsBy === 'tags') {
                        fingerprints.push(key)
                    } else if (groupErrorsBy === 'values') {
                        fingerprints.push(tags[key])
                    }
                }
            }

            for (const key in extras) {
                if (extras.hasOwnProperty(key)) {
                    scope.setExtra(key, extras[key])
                }
            }

            scope.setLevel(level)
            if (fingerprints.length) {
                scope.setFingerprint([...fingerprints])
            }
            getSentry().captureException(e)
        }),
        setGlobalsForErrors: ({tags, extras} = {}) => getSentry().configureScope(scope => {
            for (const key in tags) {
                if (tags.hasOwnProperty(key)) {
                    scope.setTag(key, tags[key])
                }
            }

            for (const key in extras) {
                if (extras.hasOwnProperty(key)) {
                    scope.setExtra(key, extras[key])
                }
            }
        }),
        breadcrumb: (messageContent, additionalData = {}) => getSentry().addBreadcrumb({
            message: messageContent,
            data: additionalData
        }),
        interactionStarted: i => fedopsLogger.interactionStarted(i),
        interactionEnded: i => fedopsLogger.interactionEnded(i),
        appLoadingPhaseStart: phase => fedopsLogger.appLoadingPhaseStart(phase),
        appLoadingPhaseFinish: phase => fedopsLogger.appLoadingPhaseFinish(phase),
        appLoaded: () => fedopsLogger.appLoaded()
    }
}

module.exports = createLogger
